module.exports = __webpack_public_path__ + "img/20200228150847360截图20200228145503864.dd95f50b.jpg";